import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

export default class PortalReservationAddOns extends React.Component {
	
  constructor(props) {
		super(props)

    this.state = {
      reservation_segment: this.props.reservation_segment
    }  

    // default to segment if only one
    if (!this.props.reservation_segment && this.props.reservation && this.props.reservation.reservation_segments.length === 1) {
      this.state.reservation_segment = this.props.reservation.reservation_segments[0]
    }

    this.onSelectReservationSegment = this.onSelectReservationSegment.bind(this);  
	}

  render() {
    return (
      <div className="PortalReservationAddOns">
        {!this.state.reservation_segment && this.renderRoomSelection()}
        {this.state.reservation_segment && this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <h4 className="text-center">
          {I18n.t('manage_add_ons')}:{' '} 
          {this.state.reservation_segment.room_type.name},{' '} 
          {DateHelper.printDateToScreen(DateHelper.parseDateFromBackend(this.state.reservation_segment.check_in_date), this.props.date_format)} &ndash;{' '} 
          {DateHelper.printDateToScreen(DateHleper.parseDateFromBackend(this.state.reservation_segment.check_out_date), this.props.date_format)}
        </h4>
      </div>
    )
  }

  renderRoomSelection() {
    return (
      <div>
        <h4 className="text-center">{I18n.t('which_room_would_you_like_to_manage_add_ons')}</h4>

        <div className="row room-selection">
          {this.renderRooms()}
        </div>
      </div>
    )
  }

  renderRooms() {
    var rooms = this.props.reservation.reservation_segments.map((segment) => {
      return (
        <div className="room well well-lg" key={segment.id}>
          <h4>{segment.room_type.name}</h4>
          <h5>{DateHelper.printDateToScreen(DateHelper.parseDateFromBackend(segment.check_in_date), this.props.date_format)} &ndash; {DateHelper.printDateToScreen(DateHelper.parseDateFromBackend(segment.check_out_date), this.props.date_format)}</h5>
          <button type="button" className="btn btn-primary" onClick={this.onSelectReservationSegment.bind(this, segment.id)}>{I18n.t('next')}</button>
        </div>
      );
    });

    return rooms
  }

  onSelectReservationSegment(reservation_segment_id) {
    var reservation_segment = null
    for (var i = 0, ilen = this.props.reservation.reservation_segments.length; i < ilen; i++) {
      reservation_segment = this.props.reservation.reservation_segments[i]
      if (reservation_segment.id === reservation_segment_id) {
        break
      }
    }
    this.setState({reservation_segment: reservation_segment})
  }
  
}
